<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox">
      <div class="optiontext">链接类型：</div>
      <el-radio-group v-model="linktyperadio">
        <el-radio :label="1">派单</el-radio>
        <el-radio :label="0">内推</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox">
      <div class="optiontext">关注类型：</div>
      <el-radio-group v-model="followtyperadio">
        <el-radio :label="1">常规二维码</el-radio>
        <el-radio :label="2">非强制二维码</el-radio>
        <el-radio :label="3">强制二维码</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox">
      <div class="optiontext">二维码展示：</div>
      <div style="position: relative; display: inline-block;">
        <el-switch
          v-model="erweima"
          :width="60"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-value="1"
          :inactive-value="0"
        />
        <div
          v-if="erweima === 1"
          style="color: #fff;position: absolute;top: 2px;left: 7px;"
        >开启</div>
        <div
          v-else
          style="color: #fff;position: absolute;top: 2px;right: 7px;"
        >关闭</div>
      </div>
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      name: '',
      linktyperadio: 1,
      followtyperadio: 3,
      erweima: 1
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {

  },
  methods: {
    async sumbit() {
      console.log('this.objquery', this.objquery)
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }

      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          sourceuuid: this.objquery.bookid,
          articleuuid: this.objquery.chapterid,
          // book_name: this.objquery.bookname,
          chapter_name: this.objquery.chaptername,
          link_name: this.name,
          link_group: this.linktyperadio,
          qrcode_open_status: this.erweima,
          link_classify: this.followtyperadio
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
      // console.log(' this.chaunarr', this.chaunarr)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
